'use client';

import { Stack, Typography } from '@mui/material';
import type { InventoryResource } from '@repo/api-gw-sdk';
import { useState } from 'react';
import { ButtonWithIcon } from '@/components/buttons/buttonWithIcon';
import { Loader } from '@/components/shared/loader';
import { useDAL } from '@/contexts/useDAL';
import { useRoles } from '@/contexts/useRoles';
import { settingsSummary } from './gcpSqlVmBackupSettings';
import { GcpSqlVmBackupSettingsDialog } from './gcpSqlVmBackupSettingsDialog';
export const GcpSqlVmBackupSettingsField = ({
  item
}: {
  item: InventoryResource;
}) => {
  const dal = useDAL();
  const {
    isAuthorized
  } = useRoles();
  const [isEditing, setIsEditing] = useState(false);
  const {
    data,
    isLoading,
    error,
    mutate
  } = dal.inventory.configuration.useGet(item.id);
  if (isLoading) {
    return <Loader size='medium' />;
  }
  if (error) {
    return <Typography>--</Typography>;
  }
  const settings = data?.gcpSqlVmBackupSettings ?? undefined;
  return <Stack direction='row' sx={{
    alignItems: 'center',
    gap: '8px'
  }}>
      <Typography>{settingsSummary(settings)}</Typography>
      <ButtonWithIcon text='Edit' variant='text' icon='material-symbols-edit-outline-rounded' isAuthorized={isAuthorized('update:inventory')} onClick={() => setIsEditing(true)} dataTestId='gcp-sql-vm-backup-settings-edit-button' />
      {isEditing && <GcpSqlVmBackupSettingsDialog resourceId={item.id} settings={settings} onClose={() => setIsEditing(false)} onSaved={() => mutate()} />}
    </Stack>;
};